import React from 'react';
import {Label as RUILabel} from '@radix-ui/react-form';
import classNames from 'classnames';
import styles from './label.module.scss';

interface LabelProps {
  children: string | React.ReactElement;
  className?: string;
  kind?: 'default' | 'light';
}

const Label = ({
  children,
  kind = 'default',
  className,
}: LabelProps) => {
  return (
    <RUILabel asChild className={classNames({[styles.label]: kind === 'default', [styles.light]: kind === 'light'}, className)}>
      {typeof children === 'string' ? (
        <span>
          {children}
        </span>
      ) : (
        {children}
      )}
    </RUILabel>
  );
};

export default Label;
